export default {
  mounted() {
    this.popPage();
  },
  methods: {
    popPage() {
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, -999);
    }
  }
};
